import React, { useState } from 'react';
import './App.css';
import ArticleDetails from './pages/ArticleDetails';
import Home from './pages/Home';
import SearchResults from './pages/SearchResults';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedArticle, setSelectedArticle] = useState(null);

  const handleSearch = (query) => {
    setSearchQuery(query);
    setCurrentPage('results');
  };

  const handleBackToHome = () => {
    setCurrentPage('home');
    setSearchQuery('');
    setSelectedArticle(null);
  };

  const handleBackToResults = () => {
    setCurrentPage('results');
    setSelectedArticle(null);
  };

  const handleArticleClick = (article) => {
    setSelectedArticle(article);
    setCurrentPage('article');
  };

  const handleRelatedArticleClick = (relatedArticle) => {
    // Navigate to the related article
    setSelectedArticle(relatedArticle);
    setCurrentPage('article');
  };

  return (
    <div className="App">
      {currentPage === 'home' && (
        <Home onSearch={handleSearch} />
      )}
      {currentPage === 'results' && (
        <SearchResults
          searchQuery={searchQuery}
          onBackToHome={handleBackToHome}
          onArticleClick={handleArticleClick}
        />
      )}
      {currentPage === 'article' && selectedArticle && (
        <ArticleDetails
          article={selectedArticle}
          onBackToResults={handleBackToResults}
          onBackToHome={handleBackToHome}
          onRelatedArticleClick={handleRelatedArticleClick}
        />
      )}
    </div>
  );
}

export default App;
